export default __webpack_public_path__ + "static/media/1961.bed06193.png";